import { Trash2 } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { DropdownMenuItem } from '@/components/ui/dropdown-menu';

import { useDeleteAgentMutation } from '@/query/agent.query';

type Props = {
  agentId: number;
};

export const DeleteButton = ({ agentId }: Props) => {
  const navigate = useNavigate();
  const mutation = useDeleteAgentMutation({
    onSuccess: () => {
      navigate('/agents');
    },
  });

  return (
    <DropdownMenuItem variant="destructive" onClick={() => mutation.mutate(agentId)}>
      <Trash2 className="h-4 w-4" />
      Delete Agent
    </DropdownMenuItem>
  );
};
